import { css } from 'styled-components'
import { color, fontSize, height, margin, padding, screen } from 'theme/mixins'

const tabStyles = css`
	.ant-tabs-tab {
		min-width: 50px;
		display: inline-flex;
		justify-content: center;
	}

	.ant-tabs-tab + .ant-tabs-tab {
		margin-left: ${margin('xxs')};
	}

	${screen.gte.xs`
		.ant-tabs-tab + .ant-tabs-tab {
			margin-left: ${margin('lg')};
		}
	`}
`

const menuStyles = css`
	.ant-menu {
		border: none;
	}
`

const tableStyles = css`
	.ant-table-empty {
		min-height: 250px;
	}

	.ant-result-icon {
		display: none;
	}
`

const inputStyled = css`
	input[type='text'] {
		min-width: 250px;
	}

	.ant-picker,
	.ant-input-number {
		width: 100% !important;
	}

	.ant-input-number-handler-wrap {
		display: none;
	}

	.ant-picker-panels {
		flex-direction: column;
	}

	${screen.gte.sm`
		.ant-picker-panels {
			flex-direction: row;
		}
	`}
`

const buttonStyles = css`
	.ant-btn-icon-only {
		min-width: ${height('md')};
	}

	button.ant-btn-sm {
		min-width: ${height('sm')};
	}

	/* custom invert type */
	.ant-btn-invert {
		color: ${color('primary')};
		border-color: ${color('primary')};

		&:hover {
			color: ${color('white')};
			background: ${color('primary')};
		}
	}
`

const formStyles = css`
	.ant-form {
		.ant-collapse {
			margin-bottom: ${margin('md')};
		}

		.ant-form-item-explain {
			margin-top: ${margin('xs')};
		}
	}
`

const checkboxStyles = css`
	// Fix checkbox & checkbox label not being properly aligned
	.ant-checkbox-wrapper {
		align-items: center;

		> span {
			padding: 0;
		}

		.anticon {
			font-size: 16px;
		}
	}

	.ant-checkbox {
		top: 0;
		margin-right: ${margin('xs')};
	}
`

const uploadStyles = css`
	.ant-upload {
		min-height: 300px;
		display: flex;
		align-items: center;
		justify-content: center;

		.ant-upload-text {
			padding: 0 ${padding('md')};
			white-space: break-spaces;
		}
	}
`

const listStyles = css`
	.ant-list {
		.ant-list-empty-text {
			padding: 0;
		}
	}
`

const statisticStyles = css`
	.ant-statistic-content {
		display: flex;
		align-items: center;
		font-size: ${fontSize('xxl')};
	}
`

const stepStyles = css`
	.ant-steps-item-title {
		line-height: 32px;
	}

	.ant-steps-item-title {
		&::after {
			top: ${margin('sm')};
			background-color: ${color('primary')} !important;
		}
	}

	.ant-steps-item-tail {
		&::after {
			background-color: ${color('primary')} !important;
		}
	}
`

const resultStyles = css`
	.ant-result-title {
		line-height: 1.5;
	}
`

const modalStyles = css`
	.ant-modal {
		top: 0;
	}

	.ant-modal-header {
		padding: ${padding('sm')};
	}

	.ant-modal-body {
		padding: 0 ${padding('sm')} ${padding('sm')};
	}

	${screen.gte.md`
		.ant-modal {
			top: 100px;
		}

		.ant-modal-header {
			padding: ${padding('xl')};
		}

		.ant-modal-body {
			padding: 0 ${padding('xl')} ${padding('xl')};
		}
	`}
`

const popoverStyles = css`
	.ant-popover-inner-content {
		padding: ${padding('xs')};
	}

	.ant-popover-message {
		padding-bottom: ${padding('xxs')};
	}
	${screen.gte.xs`
		.ant-popover-inner-content {
			padding: ${padding('sm')};
		}

		.ant-popover-message {
			padding-bottom: ${padding('xs')};
		}
	`}
`

const badgeStyles = css`
	.ant-badge {
		.ant-scroll-number-only-unit {
			font-size: ${fontSize('xs')};
		}

		.ant-badge-dot,
		.ant-badge-count {
			right: -2px;
		}
	}
`

const tooltipStyles = css`
	.ant-tooltip {
		max-width: 260px;
	}
`

export default css`
	${tabStyles}
	${menuStyles}
	${tableStyles}
	${inputStyled}
	${buttonStyles}
	${checkboxStyles}
	${formStyles}
	${uploadStyles}
	${listStyles}
	${statisticStyles}
	${stepStyles}
	${resultStyles}
	${modalStyles}
	${popoverStyles}
	${badgeStyles}
	${tooltipStyles}
`
